import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("enbissy_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const GUEST_MSG = "Modalità ospite: registrati per continuare.";

export function leaveGuestToRegister() {
  localStorage.removeItem("enbissy_token");
  window.location.href = "/?register=1";
}

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 403 && error.response?.data?.detail === "GUEST_ACTION") {
      error.response.data.detail = GUEST_MSG;
      toast.error(GUEST_MSG, { id: "guest-action", action: { label: "Registrati", onClick: leaveGuestToRegister } });
    }
    return Promise.reject(error);
  }
);

export function fileUrl(url) {
  if (!url) return null;
  if (url.startsWith("/api/files")) {
    const token = localStorage.getItem("enbissy_token");
    return `${BACKEND_URL}${url}${token ? `?auth=${token}` : ""}`;
  }
  return url;
}

export function apiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
